export default "__VITE_ASSET__DZ_$1y5L__"